// src/components/AGTUps/services/transactionService.js

import API_CONFIG, { api } from './config';

const TRANSACTIONS_ENDPOINT = '/transactions';

/**
 * Obtiene la lista de transacciones del usuario.
 * Puedes pasar parámetros de filtrado (por ejemplo, por fecha, tipo, etc.) a través de "params".
 */
const getTransactions = async (params = {}) => {
  try {
    const response = await api.get(`${API_CONFIG.BASE_URL}${TRANSACTIONS_ENDPOINT}`, { params });
    return response.data;
  } catch (error) {
    throw new Error(API_CONFIG.ERROR_HANDLERS.formatErrorMessage(error));
  }
};

/**
 * Crea una nueva transacción.
 */
const createTransaction = async (data = {}) => {
  try {
    const response = await api.post(`${API_CONFIG.BASE_URL}${TRANSACTIONS_ENDPOINT}`, data);
    return response.data;
  } catch (error) {
    throw new Error(API_CONFIG.ERROR_HANDLERS.formatErrorMessage(error));
  }
};

/**
 * Confirma y registra la transacción definitiva.
 * Se espera que el objeto "transactionData" ya esté mapeado y confirmado por el usuario.
 */
const confirmTransaction = async (transactionData = {}) => {
  try {
    const response = await api.post(`${API_CONFIG.BASE_URL}${TRANSACTIONS_ENDPOINT}/confirm`, { transactionData });
    return response.data;
  } catch (error) {
    throw new Error(API_CONFIG.ERROR_HANDLERS.formatErrorMessage(error));
  }
};

/**
 * Actualiza una transacción existente.
 * Se espera que se pase el ID de la transacción y los datos actualizados.
 */
const updateTransaction = async (transactionId, data = {}) => {
  try {
    const response = await api.put(`${API_CONFIG.BASE_URL}${TRANSACTIONS_ENDPOINT}/${transactionId}`, data);
    return response.data;
  } catch (error) {
    throw new Error(API_CONFIG.ERROR_HANDLERS.formatErrorMessage(error));
  }
};

/**
 * Elimina una transacción.
 */
const deleteTransaction = async (transactionId) => {
  try {
    const response = await api.delete(`${API_CONFIG.BASE_URL}${TRANSACTIONS_ENDPOINT}/${transactionId}`);
    return response.data;
  } catch (error) {
    throw new Error(API_CONFIG.ERROR_HANDLERS.formatErrorMessage(error));
  }
};

// Asignar el objeto a una variable antes de exportarlo
const transactionService = {
  getTransactions,
  createTransaction,
  confirmTransaction,
  updateTransaction,
  deleteTransaction,
};

export default transactionService;